<template>
  <div class="view-integrat">
    <div class="mb-6">
      <h4 class="text-semibold">Unifast</h4>
      <small>Integre sua Secretaria Digital ao ZeusPay</small>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <form-group
          v-model="product_id"
          select
          id="product-select"
          label="Produto"
          placeholder="Selecionar produto"
          :options="products.map(({ id, name }) => ({ id, name }))"
        />
      </div>
    </div>
    <template v-if="product_id">
      <snow-data-table-header
        @add="add"
        :datePicker="false"
        @searching="searching"
        :disable-add="!!integrationList.length"
        disabled_tooltip_msg="Será possível adicionar apenas 1 integração por produto. Exclua ou edite a existente."
      />

      <div v-if="loading" class="text-center pt-6">
        <b-spinner variant="primary" />
      </div>

      <template v-else>
        <div
          v-if="!integrationList.length"
          class="container centralize-row text-center pt-5"
        >
          <div class="row justify-content-center">
            <div class="col-lg-5">
              <img
                class="d-block mb-9 mx-auto"
                src="@/assets/images/no-content.svg"
              />
              <h5>Você ainda não adicionou nenhuma integração</h5>
              <div class="text-secondary mb-5">
                Clique no botão acima para cadastrar
              </div>
            </div>
          </div>
        </div>
        <!-- Desktop area -->
        <template v-else>
          <data-table
            new-design
            class="d-none d-lg-block"
            columnsFr="1fr 1fr 1fr 0.2fr 0.2fr"
            :columns="columns"
            :data="integrationList"
          >
            <template #default="{ item }">
              <div class="crop">
                <span>
                  {{ get_product(item.product_id) }}
                </span>
              </div>
              <div class="crop">
                <span>
                  {{ item.company_name }}
                </span>
              </div>
              <div class="crop">
                <span>
                  {{ item.token_signature }}
                </span>
              </div>
              <div>
                <span :class="statusClass(item.status)">
                  {{ item.status ? "Ativo" : "Inativo" }}
                </span>
              </div>
              <div class="d-flex justify-content-end">
                <actions-dropdown
                  :left="false"
                  :right="true"
                  :actions="getActions(item)"
                  @edit="edit(item)"
                  @delete="submitDelete(item)"
                  @change-status="changeStatus(item)"
                />
              </div>
            </template>
          </data-table>
          <!-- Desktop area -->
          <!-- Mobile area -->
          <data-table
            new-design
            class="d-lg-none"
            :columns="['', '']"
            :data="integrationList"
          >
            <template #default="{ item }">
              <div class="responsive-table">
                <span>
                  <strong>Produto: </strong>
                  {{ get_product(item.product_id) }}
                </span>
                <span>
                  <strong>Empresa: </strong>
                  {{ item.company_name }}
                </span>
                <span>
                  <strong>Token: </strong>
                  {{ item.token_signature }}
                </span>
                <span>
                  <strong>Status: </strong>
                  <strong :class="statusClass(item.status)">
                    {{ item.status ? "Ativo" : "Inativo" }}
                  </strong>
                </span>
              </div>
              <div class="d-flex justify-content-end">
                <actions-dropdown
                  :left="false"
                  :right="true"
                  :actions="getActions(item)"
                  @edit="edit(item)"
                  @delete="submitDelete(item)"
                  @change-status="changeStatus(item)"
                />
              </div>
            </template>
          </data-table>
        </template>
        <!-- Mobile area -->
        <div class="d-flex justify-content-end mt-4">
          <snow-paginator
            v-model="page"
            :pagination="pagination"
            @change-page="dispatch"
          />
        </div>
      </template>
    </template>
    <template v-else>
      <div class="row justify-content-center pt-6">
        <div class="col-lg-5 text-center">
          <img
            class="d-block mb-6 mx-auto"
            src="@/assets/images/no-content.svg"
          />
          <h5>Primeiro, escolha o produto</h5>
        </div>
      </div>
    </template>

    <integration-modal
      v-model="modal"
      title="Unifast"
      link="https://unifast.com.br/"
    >
      <integrat-modal
        :integrationToEdit="integrationToEdit"
        :product_id="product_id"
        @close="modal = false"
        @update-list="dispatch"
      />
    </integration-modal>
  </div>
</template>
<script>
import IntegratModal from "@/components/tools/modals/member-area/Integrat.vue";
import IntegrationsMixin from "@/mixins/integration.js";
import get from "lodash/get";

export default {
  mixins: [IntegrationsMixin],
  components: {
    IntegratModal
  },
  data() {
    return {
      integration: "integrat",
      product_id: null,
      columns: ["Produto", "Empresa", "Token", "Status", ""],
      breadcrumbs: [
        { title: "Ferramentas", link: "tools" },
        { title: "Certificações MEC", link: "tools-mec-certifications" },
        { title: "Unifast" }
      ]
    };
  },
  watch: {
    product_id() {
      this.$store.commit("integration/setPagination", {});
      this.$store.commit("integration/setIntegrationList", []);
      this.dispatch();
    }
  },
  mounted() {
    this.$store.commit("integration/setIntegration", this.integration);
    this.$store.dispatch("product/get", { limit: 1000 });
  },
  methods: {
    dispatch() {
      if (this.product_id) {
        this.loading = true;
        this.$store
          .dispatch("integration/getIntegrat", this.product_id)
          .finally(() => {
            this.loading = false;
          });
      }
    },
    get_product(id) {
      return get(
        this.products.find(p => p.id === id),
        "name",
        "-"
      );
    },
    submitDelete(item) {
      if (this.loading) return;

      this.loading = true;
      this.$store
        .dispatch("integration/deleteIntegration", item.product_id)
        .then(() => {
          this.dispatch();
          this.$message.success("Integração removida");
          this.$store.commit("integration/setPagination", {});
          this.$store.commit("integration/setIntegrationList", []);
        })
        .catch(error => {
          let msg = get_error_msg(
            error.response.data,
            TRANSLATE_FIELD_INTEGRATION_MAP,
            "Não foi possível deletar a conta integrada"
          );
          this.$message.error(msg);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
